import axios from 'axios'
import { Tag, User, Camera, Detection } from '../types'

let headerGenerator = (urlEnding: string, data: any) => {
    return {
        method: "POST",
        url: process.env.REACT_APP_SERVER + urlEnding,
        data: data,
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('token'),
            'Content-Type': 'application/x-www-form-urlencoded'
        },
    }
};

interface authenticateResponse {
    data: {
        code: number
        expire: string
        token: string
    }
}

interface DetectorForm {
    id: string
    Tag: {
        name: string
        time: null | {
            from: string
            to: string
        }
        boundingBox: null | {
            x: number
            y: number
            w: number
            h: number
        }
        negativeDetection: boolean
    }
}

export interface newTagReq {
    name: string,
    time: null | {
        from: string,
        to: string
    },
    boundingBox: null | {
        x: number,
        y: number,
        w: number,
        h: number,
    },
    negativeDetection: boolean
}

export interface getCameraTagsResponseInterface {
    data: {
        tags: Tag[]
        stream: string
    }
}

export interface getUserResponseInterface {
    data: {
        user: User,
        cameras: Camera[] | undefined
    }
}

export default class Datafetcher {
    //username :: STRING
    //password :: STRING
    //callback :: ERROR -> OBJECT -> (ERROR, OBJECT)
    authenticateUser(email: string, password: string,
        callback: (a: any, b: authenticateResponse | null) => void) {
        axios(headerGenerator('/login', {
            Email: email,
            Password: password
        })).then(function (response: authenticateResponse) {
            callback(null, response);
        }).catch(function (error: any) {
            callback(error, null);
        });
    }

    //username :: STRING
    //email :: STRING
    //password :: STRING
    //phone :: STRING
    //callback :: ERROR -> OBJECT -> (ERROR, OBJECT)
    signUpUser(email: string, fullname: string, password: string, phone: string, callback: (a: any, b: string | null) => void) {
        axios(headerGenerator('/api/new_user', {
            Email: email,
            Name: fullname,
            Password: password,
            Phone: phone,
        })).then(function (response: string) {
            callback(null, response);
        }).catch(function (error: any) {
            callback(error, null);
        });
    }

    //nickname :: STRING
    //url :: STRING
    //adminUrl :: STRING
    //location :: STRING
    //callback :: ERROR -> OBJECT -> (ERROR, OBJECT)
    addNewCamera(nickname: string, url: string, timezone: string, callback: (a: Error | null, b: string | null) => void) {
        console.log(timezone)
        axios(headerGenerator('/secure/api/add_camera_to_user', {
            Nickname: nickname,
            Url: url,
            Timezone: timezone,
        })).then(function (response: "Success") {
            callback(null, response);
        }).catch(function (error: Error) {
            callback(error, null);
        });
    }

    //url :: STRING
    //callback :: ERROR -> OBJECT -> (ERROR, OBJECT)
    removeCamera(url: String, callback: (a: Error | null, b: string | null) => void) {
        axios(headerGenerator('/secure/api/delete_camera', {
            id: url,
        })).then(function (response: "Success") {
            callback(null, response);
        }).catch(function (error: Error) {
            callback(error, null);
        });
    }

    //url :: STRING
    // tag :: { 
    //     name :: STRING,
    //     time :: { 
    //         from :: STRING, 
    //         to :: STRING }, 
    //     boundingBox :: {
    //         x, y, w, h :: INT
    //     }, 
    //     negativeDetection :: BOOLEAN 
    // }
    //callback :: ERROR -> OBJECT -> (ERROR, OBJECT)
    addNewTag(url: string, tag: newTagReq, callback: (a: Error | null, b: string | null) => void) {
        axios(headerGenerator('/secure/api/add_tag', {
            id: url,
            Tag: tag,
        })).then(function (response: string) {
            callback(null, response);
        }).catch(function (error: Error) {
            callback(error, null);
        });
    }

    //url :: STRING
    // tag :: { 
    //     name :: STRING,
    //     time :: { 
    //         from :: STRING, 
    //         to :: STRING }, 
    //     boundingBox :: {
    //         x, y, w, h :: INT
    //     }, 
    //     negativeDetection :: BOOLEAN 
    // }
    //callback :: ERROR -> OBJECT -> (ERROR, OBJECT)
    editTag(url: string, tag: DetectorForm["Tag"], callback: (a: Error | null, b: string | null) => void) {
        axios(headerGenerator('/secure/api/edit_tag', {
            id: url,
            Tag: tag,
        })).then(function (response: string) {
            callback(null, response);
        }).catch(function (error: Error) {
            callback(error, null);
        });
    }

    //url :: STRING
    //tag :: STRING
    //callback :: ERROR -> OBJECT -> (ERROR, OBJECT)
    removeTag(url: string, tag: string, callback: (a: Error | null, b: string | null) => void) {
        axios(headerGenerator('/secure/api/remove_tag', {
            id: url,
            Tag: tag,
        })).then(function (response: string) {
            callback(null, response);
        }).catch(function (error: Error) {
            callback(error, null);
        });
    }

    //url :: STRING
    //tag :: STRING
    //time :: ENUM : INT (0-7)
    //callback :: ERROR -> OBJECT -> (ERROR, OBJECT)
    pauseTag(id: string, tag: string, time: number, callback: (a: Error | null, b: string | null) => void) {
        axios(headerGenerator('/secure/api/pause_tag', {
            id: id,
            Tag: tag,
            Time: time
        })).then(function (response: string) {
            callback(null, response);
        }).catch(function (error: Error) {
            callback(error, null);
        });
    }

    //url :: STRING
    //callback :: ERROR -> OBJECT -> (ERROR, OBJECT)
    getCameraTags(url: string, callback: (a: Error | null, b: getCameraTagsResponseInterface | null) => void) {
        axios(headerGenerator('/secure/api/get_camera_tags', {
            id: url,
        })).then(function (response: getCameraTagsResponseInterface) {
            callback(null, response);
        }).catch(function (error: Error) {
            callback(error, null);
        });
    }

    //callback :: ERROR -> OBJECT -> (ERROR, OBJECT)
    getUserInfo(callback: (a: Error | null, b: getUserResponseInterface | null) => void) {
        axios(headerGenerator('/secure/api/get_user_info', {}))
            .then((response: getUserResponseInterface) => callback(null, response))
            .catch((error: Error) => callback(error, null))
    }

    //oldPassword :: STRING
    //newPassword :: STRING
    //callback :: ERROR -> OBJECT -> (ERROR, OBJECT)
    changePassword(oldPassword: string, newPassword: string, callback: (a: Error | null, b: string | null) => void) {
        axios(headerGenerator('/secure/api/change_password', {
            oldPassword: oldPassword,
            newPassword: newPassword
        }))
            .then(function (response: string) {
                callback(null, response);
            }).catch(function (error: Error) {
                callback(error, null);
            });
    }

    //newEmail :: STRING
    //newName :: STRING
    //callback :: ERROR -> OBJECT -> (ERROR, OBJECT)
    changeUserInfo(newEmail: string, newName: string, callback: (a: Error | null, b: string | null) => void) {
        axios(headerGenerator('/secure/api/change_user_info', {
            newEmail: newEmail,
            newName: newName
        })).then(function (response: string) {
            callback(null, response);
        }).catch(function (error: Error) {
            callback(error, null);
        });
    }

    //Payment :: STRING
    //callback :: ERROR -> OBJECT -> (ERROR, OBJECT)
    savePaymentInfo(payment_method: string, callback: any) {
        axios(headerGenerator('/secure/api/save_payment_info', {
            Payment: payment_method
        })).then(function (response: any) {
            callback(null, response);
        }).catch(function (error: any) {
            callback(error, null);
        });
    }

    //email :: STRING
    //callback :: ERROR -> OBJECT -> (ERROR, OBJECT)
    requestPasswordReset(email: string, callback: (a: Error | null, b: string | null) => void) {
        axios(headerGenerator('/api/request_password_reset', {
            email: email
        })).then(function (response: string) {
            callback(null, response);
        }).catch(function (error: Error) {
            callback(error, null);
        });
    }

    //password :: STRING
    //email :: STRING
    //token :: STRING
    //time :: STRING
    //callback :: ERROR -> OBJECT -> (ERROR, OBJECT)
    changePasswordThroughRequest(password: string, email: string, token: string, time: string, callback: (a: Error | null, b: string | null) => void) {
        axios(headerGenerator('/api/change_password', {
            password: password,
            email: email,
            token: token,
            time: time,
        })).then(function (response: string | null) {
            callback(null, response);
        }).catch(function (error: any) {
            callback(error, null);
        });
    }

    // //email :: STRING
    // //callback :: ERROR -> OBJECT -> (ERROR, OBJECT)
    // getUrl(url, sF, eF, callback) {
    //     axios(headerGenerator('/secure/api/get_footage', {
    //         id: url,
    //         from: sF,
    //         to: eF,
    //     })).then(function (response) {
    //         callback(null, response);
    //     }).catch(function (error) {
    //         callback(error, null);
    //     });
    // }


    getLogs(url: string, callback: (a: Error | null, b: { data: Detection[] | null } | null) => void) {
        axios(headerGenerator('/secure/api/get_logs', {
            id: url,
        })).then(function (response: { data: Detection[] | null }) {
            callback(null, response);
        }).catch(function (error: Error | null) {
            callback(error, null);
        });
    }

    // getObjects(url, callback) {
    //     axios(headerGenerator('/secure/api/get_analytics_objects', {
    //         id: url,
    //     })).then(function (response) {
    //         callback(null, response);
    //     }).catch(function (error) {
    //         callback(error, null);
    //     });
    // }

    // getHistogram(object, camera, callback) {
    //     axios(headerGenerator('/secure/api/get_histogram', {
    //         object: object,
    //         camera: camera,
    //     })).then(function (response) {
    //         callback(null, response);
    //     }).catch(function (error) {
    //         callback(error, null);
    //     });
    // }

    // //email :: STRING
    // //callback :: ERROR -> OBJECT -> (ERROR, OBJECT)
    // getHeatMaps(url, object, sF, eF, callback) {
    //     axios(headerGenerator('/secure/api/get_heat_map', {
    //         id: url,
    //         from: sF,
    //         to: eF,
    //         object: object,
    //     })).then(function (response) {
    //         callback(null, response);
    //     }).catch(function (error) {
    //         callback(error, null);
    //     });
    // }
}